module.exports = __webpack_public_path__ + "img/ADRABG.31c450ad.jpg";